import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const popupUserListState = atom({
  key: "popupUserListState",
  default: [],
  effects_UNSTABLE: [persistAtom], // 상태를 로컬 스토리지에 저장
});
